export const FILE_LIBRARY_INCLUDED_BYTES = 10_737_418_240;
export const FILE_LIBRARY_WARNING_RATIO = 0.8;

export type CompanyFileStatus =
  | 'uploading'
  | 'ready'
  | 'archived'
  | 'purge_pending'
  | 'purged'
  | 'failed';
export type CompanyFileMimeGroup =
  | 'all'
  | 'image'
  | 'video'
  | 'pdf'
  | 'spreadsheet'
  | 'document'
  | 'other';
export type FileSourceMode = 'local' | 'library';

export interface FileLibraryUsageDto {
  company_id: string;
  included_bytes: number;
  granted_bytes: number;
  effective_limit_bytes: number;
  used_bytes: number;
  reserved_bytes: number;
  projected_bytes: number;
  overage_bytes: number;
  used_ratio: number;
  projected_ratio: number;
  state: 'normal' | 'warning' | 'overage';
}

export interface CompanyFileDto {
  company_file_id: string;
  company_id: string;
  original_file_name: string;
  display_name: string;
  detected_mime_type: string | null;
  size_bytes: number;
  sha256: string;
  lifecycle_status: CompanyFileStatus;
  reference_count?: number;
  uploaded_by?: string | null;
  uploaded_at: string;
  ready_at?: string | null;
  created_at: string;
  updated_at: string;
  archived_at?: string | null;
  archived_by?: string | null;
}

export interface CompanyFileReferenceDto {
  reference_type: string;
  reference_id: string;
  label: string;
  created_at: string;
}

export interface CompanyFileReferencesDto {
  company_file_id: string;
  evidence_file_count: number;
  source_file_count: number;
  references: CompanyFileReferenceDto[];
}

export interface FileLibraryListResult {
  files: CompanyFileDto[];
  next_cursor?: string | null;
  usage: FileLibraryUsageDto;
}

export interface UploadCompanyFileResult {
  file: CompanyFileDto;
  usage: FileLibraryUsageDto;
  duplicate: boolean;
  restored_from_archive: boolean;
}

interface FileLibraryListFilterParams {
  q?: string;
  mime_group?: CompanyFileMimeGroup;
  status?: 'ready' | 'archived' | 'all';
  linked?: boolean;
  cursor?: string;
  limit?: number;
}

type FileLibraryOwnScope = {
  company_id?: undefined;
  batch_id?: undefined;
};

type FileLibraryCompanyScope = {
  company_id: string;
  batch_id?: never;
};

type FileLibraryBatchScope = {
  batch_id: string;
  company_id?: never;
};

export type FileLibraryListParams = FileLibraryListFilterParams &
  (FileLibraryOwnScope | FileLibraryCompanyScope | FileLibraryBatchScope);

export interface UploadCompanyFileInput {
  file: File;
  company_id?: string;
  idempotency_key?: string;
}

export interface FileLibrarySelection {
  company_file_id: string;
  display_name: string;
  detected_mime_type: string | null;
  size_bytes: number;
  sha256: string;
}
